/**
 * The number of milliseconds before the associated {@link Trip} start the time should be for a
 * {@link TripAnnotation}.
 */
export default 1;
